import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deeplink-mb',
  templateUrl: './deeplink-mb.component.html',
  styleUrls: ['./deeplink-mb.component.scss']
})
export class DeeplinkMBComponent implements OnInit {
  isLoading = true
  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.toMiniapp()
    }, 1000);
  }
  toMiniapp(){
    window.location.href = 'mbbank://?ad_dp=marketplaceapp&code=PHZTOMOTEK';
  }

}
